var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7841 21.0156L0.93457 3.16604L3.15115 0.949463L21.0007 18.799L18.7841 21.0156Z",
    fill: "#0070BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.934823 18.799L18.7844 0.949463L21.001 3.16604L3.15141 21.0156L0.934823 18.799Z",
    fill: "#0070BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnX);
export default __webpack_public_path__ + "static/media/btn-x.2757c3b14ae18273e266cae32f2d40f8.svg";
export { ForwardRef as ReactComponent };